import type { ReactNode } from "react";

import { cn } from "@/lib/cn";

import { DocsSidebar } from "./DocsSidebar";

/**
 * Documentation layout: persistent section nav, the article, and an optional
 * on-this-page rail that appears only once there is room for it.
 */
export function DocsShell({ children, aside }: { children: ReactNode; aside?: ReactNode }) {
  return (
    <div className="mx-auto w-full max-w-[90rem] px-5 py-10 sm:px-6 lg:py-14">
      <div
        className={cn(
          "lg:grid lg:justify-center lg:gap-12",
          aside
            ? "lg:grid-cols-[16rem_minmax(0,72ch)] xl:grid-cols-[16rem_minmax(0,72ch)_14rem] xl:gap-14"
            : "lg:grid-cols-[16rem_minmax(0,48rem)]",
        )}
      >
        <DocsSidebar />
        {/* A plain div, not <main>: App.tsx already wraps every route in the
            page's single main landmark, and nesting a second one is invalid
            and leaves assistive tech with two "main content" targets.
            min-w-0 stops a wide table or code block from stretching the grid
            column and putting the whole page into horizontal scroll. */}
        <div className="min-w-0">{children}</div>
        {aside ? (
          <div className="hidden xl:block">
            <div className="sticky top-24 pb-8">{aside}</div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
